import(/* webpackMode: "eager" */ "/app/src/app/(homeProviders)/error.tsx");
